import React, { useState } from "react";
import "./career_header.css";

const CareerHeader = ({ selectedTab, setSelectedTab }) => {
  const currentTab = (current) => {
    if (selectedTab === current) {
      return "active";
    } else {
      return "inactive";
    }
  };
  return (
    <div className="career-navbar-wrapper">
      <div className="career-navbar">
        <div className="nav-items">
          <a
            href="#inside-uc"
            className={currentTab("1")}
            onClick={() => {
              setSelectedTab("1");
            }}
          >
            Inside UC
          </a>
          <a
            href="#recent-jobs"
            className={currentTab("2")}
            onClick={() => {
              setSelectedTab("2");
            }}
          >
            Open positions
          </a>
          <a
            href="#perkDivid"
            className={currentTab("3")}
            onClick={() => {
              setSelectedTab("3");
            }}
          >
            Perks
          </a>
          <a
            href="#Culture"
            className={currentTab("4")}
            onClick={() => {
              setSelectedTab("4");
            }}
          >
            Culture
          </a>
          <a
            href="#UCJourney-cards"
            className={currentTab("5")}
            onClick={() => {
              setSelectedTab("5");
            }}
          >
            UC journey
          </a>
          <a
            href="#founders-section"
            className={currentTab("6")}
            onClick={() => {
              setSelectedTab("6");
            }}
          >
            Founders & leadership
          </a>
          <a
            href="#recent-jobs"
            className="button-open-position-2"
            onClick={() => {
              setSelectedTab("2");
            }}
          >
            View open positions
          </a>
        </div>
      </div>
    </div>
  );
};

export default CareerHeader;
